import { Controller } from 'stimulus'
import LazyLoad from 'vanilla-lazyload'

export default class extends Controller {
  static targets = ['teamDetailsFrame']

  connect() {
    setTimeout(() => {
      this.initLazyLoad()
    }, 750)

    const editTeamDetailsModal = document.getElementById('edit-team-details-modal')
    if (editTeamDetailsModal) {
      this.editTeamDetailsObserver = new MutationObserver(
        this.teamDetailsMutated.bind(this)
      )
      this.editTeamDetailsObserver.observe(editTeamDetailsModal, {
        childList: true,
        subtree: true,
      })
    }
  }

  teamDetailsMutated() {
    const editTeamDetailsModal = document.getElementById('edit-team-details-modal')
    if (editTeamDetailsModal?.querySelector('.success')) {
      let src = this.teamDetailsFrameTarget.getAttribute('src')
      this.teamDetailsFrameTarget.setAttribute('src', src)
    }
    setTimeout(() => {
      this.initLazyLoad()
    }, 1000)
  }

  initLazyLoad() {
    let lazyLoadOptions = { elements_selector: '.lazy' }
    window.pageLazyLoad = new LazyLoad(lazyLoadOptions)
  }
}
